<template>
    <div class="container-fluid  pt-2">
        <div class="container pt-5">
            <div class="form-group has-search"><span class="fa fa-search form-control-feedback"></span> <input v-model="searchemployee" type="text" placeholder="Search Employee" class="form-control border"></div>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-md-3 col-12">
                    <div class="py-3">
                        <h4 class="text-weight-900 text-primary">Employees</h4>
                    </div>
                </div>
                <div class="col-md-9 col-12">
                    <div class="d-flex float-right">
                        <a href="/payroll" v-if="userDetails.roles?.[0]?.name === 'Admin'" class="btn mx-1 btn-outline-primary btn-sm">Payroll </a>
                        <button v-if="userDetails.roles?.[0]?.name === 'Admin'" v-on:click="CreateEmployeeModal" class="btn mx-1 btn-outline-primary btn-sm">Create Employee <i class="fas fa-plus"></i></button>
                        <div class="dropdown">
                            <button class="btn btn-primary btn-sm dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false">
                  More...
                  </button>
                            <div class="dropdown-menu">
                                <a v-if="userDetails.roles?.[0]?.name === 'Admin'" href="/salary-advances" class="dropdown-item">Salary Advances </a>
                                <a href="/leave-applications" class="dropdown-item">Leave Applications </a>
                                <a v-if="userDetails.roles?.[0]?.name === 'Admin'" title="coming soon" href="#" class="dropdown-item di">Payouts </a>
                                <a v-if="userDetails.roles?.[0]?.name === 'Admin'" href="/attendance" class="dropdown-item">Attendance </a>
                                <a v-if="userDetails.roles?.[0]?.name === 'Admin'" href="#" class="dropdown-item" @click.prevent="openDeletedEmployeesModal">Deleted Employees</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <b-modal ref="create-employee-modal" size="lg" id="modal-center" hide-footer static>
                <h5 class="py-3">New Employee</h5>

                <hr/>
                <!-- Shared by both forms below (was previously only rendered
                     inside the has_payroll branch, so a company without
                     payroll enabled never saw why creation failed). -->
                <div v-if="employeeCreationError" class="card card-danger mb-3">
                    <div class="card-body">
                        <h3 class="text-danger">
                            Ooops! there was an error
                        </h3>
                        <ul class="mb-0">
                            <li v-for="(err, field) in employeeCreationError" :key="field">
                                <span class="text-danger">{{ err[0] }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-if="userDetails.company && userDetails.company.companysettings && userDetails.company.companysettings.has_payroll">
                    <div class="py-3">
                        <p>Will this employee be able to login to Dukakit? </p>
                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" id="customSwitch1" v-model="createForm.onlyForPayroll">
                            <label v-if="createForm.onlyForPayroll === true" class="custom-control-label" for="customSwitch1">Only Payroll Account</label>
                            <label v-if="createForm.onlyForPayroll === false" class="custom-control-label text-danger" for="customSwitch1">Both Payroll and Dukakit </label>
                        </div>
                    </div>
                    <!-- <div v-if="error" class="alert alert-danger py-2">{{ error }}</div> -->
                    <ul class="nav nav-pills mb-3" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link" :class="{active: tab==='details'}" href="#" @click.prevent="tab='details'">Details</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" :class="{active: tab==='statutory'}" href="#" @click.prevent="tab='statutory'">Bank & Statutory</a>
                        </li>
                    </ul>
                    <!-- DETAILS -->
                    <form @submit.prevent="newPayrollEmployeeSubmit" class="px-2 text-left">
                        <div v-show="tab==='details'">
                            <div class="form-row">
                                <div class="form-group col-4">
                                    <label>First Name <span class="text-danger">*</span></label>
                                    <input v-model.trim="createForm.first_name" type="text" class="form-control">
                                </div>
                                <div class="form-group col-4">
                                    <label>Middle Name </label>
                                    <input v-model.trim="createForm.middle_name" type="text" class="form-control">
                                </div>
                                <div class="form-group col-4">
                                    <label>Last Name <span class="text-danger">*</span></label>
                                    <input v-model.trim="createForm.last_name" type="text" class="form-control">
                                </div>
                            </div>
                            <div class="form-group">
                                <label>Email <span class="text-danger">*</span></label>
                                <input v-model.trim="createForm.email" type="email" class="form-control">
                            </div>
                            <div class="form-group">
                                <label>Phone <span class="text-danger">*</span></label>
                                <input v-model.trim="createForm.phone" type="tel" class="form-control">
                            </div>
                            <div class="form-group">
                                <label>Title / Role</label>
                                <input v-model.trim="createForm.title" type="text" class="form-control" placeholder="e.g., Sales Rep">
                            </div>
                            <div class="form-group">
                                <label>Employment Type <span class="text-danger">*</span></label>
                                <select v-model="createForm.modeofemployment" class="form-control">
                                  <option :value="null">— Select —</option>
                                  <option value="permanent">Permanent</option>
                                  <option value="contract">Contract</option>
                                  <option value="casual">Casual</option>
                                  <option value="intern">Intern</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Monthly Salary (KES) <span class="text-danger">*</span></label>
                                <input v-model.number="createForm.salary" type="number" min="0" class="form-control">
                            </div>
                            <div class="form-group">
                                <label>Default Leave Days</label>
                                <input v-model.number="createForm.leavedays" type="number" min="0" class="form-control">
                            </div>
                            <div class="form-group">
                                <label>Employee Code</label>
                                <input v-model.trim="createForm.employee_code" type="text" class="form-control">
                            </div>
                            <div class="form-group">
                                <label>Job Description</label>
                                <input v-model.trim="createForm.jobdescription" type="text" class="form-control">
                            </div>
                            <div class="float-right">
                                <a class="nav-link btn btn-outline-secondary" :class="{active: tab==='statutory'}" href="#" @click.prevent="tab='statutory'">Next >></a>
                            </div>
                        </div>
                        <!-- STATUTORY -->
                        <div v-show="tab==='statutory'">
                            <h6 class="text-uppercase text-muted mb-3">Statutory Identifiers</h6>
                            <div class="form-group">
                                <label>National ID <span class="text-danger">*</span></label>
                                <input v-model.trim="createForm.national_id" type="text" class="form-control">
                            </div>
                            <div class="form-group">
                                <label>KRA PIN</label>
                                <input v-model.trim="createForm.krapin" type="text" class="form-control" placeholder="A123456789B">
                            </div>
                            <div class="form-group">
                                <label>SHIF No.</label>
                                <input v-model.trim="createForm.nhif" type="text" class="form-control">
                            </div>
                            <div class="form-group">
                                <label>NSSF No.</label>
                                <input v-model.trim="createForm.nssf" type="text" class="form-control">
                            </div>
                            <h6 class="text-uppercase text-muted mb-3">Bank Details</h6>
                            <div class="form-group">
                                <label>Bank</label>
                                <input v-model.trim="createForm.bank_name" type="text" class="form-control">
                            </div>
                            <div class="form-group">
                                <label>Branch</label>
                                <input v-model.trim="createForm.bank_branch" type="text" class="form-control">
                            </div>
                            <div class="form-group">
                                <label>Account Name</label>
                                <input v-model.trim="createForm.bank_account_name" type="text" class="form-control">
                            </div>
                            <div class="form-group">
                                <label>Account Number</label>
                                <input v-model.trim="createForm.bank_account_number" type="text" class="form-control">
                            </div>
                            <h6 class="text-uppercase text-muted mb-3">Reliefs & Other Monthly Inputs</h6>
                            <div class="form-group">
                                <label>Pension Contribution (Employee)</label>
                                <input v-model.number="createForm.pension_contrib" type="number" min="0" class="form-control">
                            </div>
                            <div class="form-group">
                                <label>Insurance Premium (for relief)</label>
                                <input v-model.number="createForm.insurance_premium" type="number" min="0" class="form-control">
                            </div>
                            <div class="form-group">
                                <label>Mortgage Interest</label>
                                <input v-model.number="createForm.mortgage_interest" type="number" min="0" class="form-control">
                            </div>
                            <div class="form-group">
                                <label>HELB (Monthly)</label>
                                <input v-model.number="createForm.helb_amount" type="number" min="0" class="form-control">
                            </div>
                            <p>By submitting you agree to our terms and conditions</p>
                            <div class="float-left">
                                <a class="nav-link btn btn-outline-secondary" :class="{active: tab==='details'}" href="#" @click.prevent="tab='statutory'">Previous >></a>
                            </div>
                            <div class="float-right">
                                <button class="nav-link btn btn-primary" type="submit">Submit Details</button>
                            </div>
                        </div>
                    </form>
                </div>
                <div v-else>
                    <form @submit.prevent="newEmployeeSubmit" class="px-2 text-left">

                            <div class="form-group">
                                <label>Full Name <span class="text-danger">*</span></label>
                                <input v-model.trim="createForm.full_name" type="text" placeholder="First name Middle name Last name" class="form-control border-dark border"">
                            </div>


                        <div class="form-group py-1">
                            <label>Email <span class="text-danger">*</span></label>
                            <input type="email" class="form-control border-dark border" v-model="createForm.email" placeholder="Email" required/>
                        </div>
                        <div class="form-group py-1">
                            <label>Phone Number <span class="text-danger">*</span></label>
                            <input type="text" class="form-control border-dark border" v-model="createForm.phone" placeholder="Phone Number" required />
                        </div>
                        <div class="form-group py-1">
                            <textarea class="form-control border-dark border" v-model="createForm.jobdesc" placeholder="Brief Job Description for this position"></textarea>
                        </div>
                        <label>Password <span class="text-danger">*</span></label>
                        <div class="input-group mb-3">
                            <div class="custom-file">
                                <input class="form-control" :type="passwordVisible ? 'text' : 'password'" v-model="createForm.password" placeholder="Minimum 6 characters" required minlength="6">
                            </div>
                            <div class="input-group-append">
                                <a class="btn btn-sm btn-secondary input-group-text" @click="togglePasswordVisibility">
                                                {{ passwordVisible ? 'Hide' : 'Show' }} Password
                                                </a>
                            </div>
                        </div>
                        <div class="form-group py-1">
                            <button type="submit" class="btn btn-block btn-primary">Submit</button>
                        </div>
                    </form>
                </div>
            </b-modal>
            <b-table striped hover small sticky-header="90vh" sort-icon-left responsive="sm" class="text-sm" :items="filteredEmployees" :fields="fields" @row-clicked="RowSelected">
                <template #cell(index)="data">
                                                    <!--<span style="background: #0b2e13; width:30px !important; height:80px" class="text-light">{{ data.index + 1 }}</span>-->
                                                    <span v-bind:style="{ background: data.bg_color }">{{ data.index + 1 }}</span>
</template>

               <template #cell(name)="data">
                <p class="text-primary underline-primary text-capitalize">
                    {{
                    data.item.first_name
                        ? [data.item.first_name, data.item.middle_name, data.item.last_name]
                            .filter(Boolean)   // remove null, undefined, empty string
                            .join(" ")
                        : data.item.users.name
                    }}
                </p>
                </template>


                <template #cell(job_title)="data">
                    <!--<span style="background: #0b2e13; width:30px !important; height:80px" class="text-light">{{ data.index + 1 }}</span>-->
                    <p class="text-primary underline-primary">{{ data.item.title }}</p>
                </template>
                <template #cell(modeofemployment)="data">
                    <!--<span style="background: #0b2e13; width:30px !important; height:80px" class="text-light">{{ data.index + 1 }}</span>-->
                    <p class="text-primary underline-primary">{{ data.item.modeofemployment }}</p>
                </template>



            </b-table>



            <!--Page modals-->
            <b-modal ref="employee_profile" id="modal-lg" size="xl" hide-footer  static>
                <div class="row">
                    <div class="col-md-4 col-12">
                        <div class="card">

                            <div class="card-body">
                                <div class="text-right">
                                    <a type="button" class="btn btn-sm px-2 btn-outline-secondary dropdown-toggle" data-toggle="dropdown" aria-expanded="false">Action</a>
                                    <div class="dropdown-menu">
                                        <a class="dropdown-item" v-on:click="ShowRoleModal(employeeProfile.id)">Change user role</a>
                                        <a class="dropdown-item" v-on:click="changePasswordModal(employeeProfile.id)">Change Password</a>
                                        <a class="dropdown-item" v-on:click="setEmployeePinModal(employeeProfile.id)">Set Employee code and PIN</a>
                                        <a class="dropdown-item" v-on:click="setPermissionModal(employeeProfile.id)">Add/Revoke Permissions</a>
                                        <a class="dropdown-item" v-on:click="EditEmployeeModal()" >Edit</a>
                                        <a class="dropdown-item" v-on:click="DeleteEmployeeModal(employee_id)">Delete</a>
                                    </div>
                                </div>

                                <div v-if="employeeProfile.avatar=== ''" class="text-center pb-3">
                                    <i class="fas fa-user-circle fa-5x"></i>
                                </div>

                                <div v-else="employeeProfile.avatar !== ''" class="text-center pb-3">
                                    <img class="img-bordered border-primary rounded-circle" :src="employeeProfile.avatar" style="width: 80px; height: 80px;" />

                                </div>

                                <h6 class="py-2 text-weight-400 text-capitalize"><span class="text-weight-700">Name: </span>{{ (employeeProfile && employeeProfile.users)? employeeProfile.users.name : ''}}</h6>
                                <h6 class="py-2 text-weight-400"><span class="text-weight-700">Joined: </span>{{FormatDate((employeeProfile && employeeProfile.users)? employeeProfile.users.created_at : '')}}</h6>
                              <h6 v-if="employeeProfile.employee_code" class="py-2 text-weight-400"><span class="text-weight-700">Employee Code: </span>{{employeeProfile.employee_code}}</h6>
                              <h6 class="py-2 text-weight-400"><span class="text-weight-700">Position: </span>{{employeeProfile.title}}</h6>
                              <h6 class="py-2 text-weight-400"><span class="text-weight-700">Phone: </span>{{(employeeProfile && employeeProfile.users) ? employeeProfile.users.phone : 'N/A'}}</h6>
                              <h6 class="py-2 text-weight-400"><span class="text-weight-700">Email: </span>{{(employeeProfile && employeeProfile.users) ? employeeProfile.users.email : 'N/A'}}</h6>
                                <h6 class="py-2 text-weight-400"><span class="text-weight-700">Role: </span>{{employeeProfile.roles}}</h6>
                                <!--<h6 class="py-2 px-2 text-weight-300 text-left"><span class="text-weight-700">Role: </span><ul class="list-inline"><li class="list-inline-item" v-for="role in employeeProfile.roles">{{role}},</li></ul></h6>-->



                            </div>

                        </div>

                    </div>
                    <div class="col-md-8 col-12">
                        <date-range-picker :auto-apply="autoApply" v-model="dateRange" class="custom-width-datepicker"
                    :ranges="false">
<template #input="picker" style="width: 100% !important;">
    <p v-if="picker.startDate !==null && picker.endDate !==null">
        {{ FormatDate(dateRange.startDate) }} - {{ FormatDate(picker.endDate) }}</p>
    <p v-else><i class="bi bi-calendar-event"></i> Filter by Date</p>
</template>
                </date-range-picker>
                        <div class="row">
                            <div class="col-4  border-dark border-right">


                                    <div class="text-dark">
                                        <div class="text-center">
                                            <i class="bi bi-cash-stack" style="font-size: 1.8em"></i>
                                            <h6 class="text-font-400 text-dark py-1" v-if="employeeProfile && employeeProfile.earnings.salary" >{{convertCurrencyToShillings(employeeProfile.earnings.salary)}}</h6>
                                            <h6 class="text-font-400 text-dark py-1" v-else >0</h6>
                                            <small class="text-dark">Salary</small>

                                        </div>

                                    </div>
                                </div>
                            <div class="col-4 border-dark border-right">

                                <div class="text-dark">
                                    <div class="text-center">
                                        <i class="bi bi-graph-up" style="font-size: 1.8em"></i>
                                        <h6 class="text-font-400 text-dark py-1" v-if="employeeProfile && employeeProfile.earnings.commission" >{{convertCurrencyToShillings(employeeProfile.earnings.commission)}}</h6>
                                        <h6 class="text-font-400 text-dark py-1" v-else >0</h6>
                                        <small class="text-dark">Commission</small>

                                    </div>

                                </div>




                            </div>
                            <div class="col-4">


                                    <div class="text-dark">
                                        <div class="text-center">
                                            <i class="bi bi-cart-check-fill" style="font-size: 1.8em"></i>



                                            <h6 class="text-font-400 text-dark py-1" v-if="employeeProfile.sumOfOrders" >{{convertCurrencyToShillings(employeeProfile.sumOfOrders)}}</h6>
                                            <small class="text-dark">Total Sales value</small>
                                            <!-- <hr class="m-0" /> -->
                                            <!-- <p class="text-font-400 text-dark py-1" > Orders made - {{this.employeeProfile.users.orders.length}}</p> -->



                                        </div>

                                    </div>




                            </div>
                        </div>
                        <hr/>
                        <div class="row">
                            <div class="col-4  border-dark border-right">


                                <div class="text-dark">
                                    <div class="text-center">
                                        <i class="bi bi-cash-stack" style="font-size: 1.8em"></i>
                                        <h6 class="text-font-700 text-dark py-1" v-if="employeeProfile && (employeeProfile.earnings.salary || employeeProfile.earnings.commission )" >{{convertCurrencyToShillings(employeeProfile.earnings.salary + employeeProfile.earnings.commission)}}</h6>
                                        <h6 class="text-font-400 text-dark py-1" v-else >0</h6>
                                        <small class="text-dark">Total Earnings</small>

                                    </div>

                                </div>
                            </div>
                            <div class="col-4 border-dark border-right">

                                <div class="text-dark">
                                    <div class="text-center">
                                        <i class="bi bi-graph-down" style="font-size: 1.8em"></i>

                                        <h6 class="text-font-400 text-dark py-1" v-if="employeeProfile" >{{convertCurrencyToShillings(employeeProfile.deductionSum)}}</h6>
                                        <h6 class="text-font-700 text-dark py-1" v-else >0</h6>
                                        <small class="text-dark">Total Deductions</small>
                                       <p>
                                           <a v-on:click="ShowDeductions" title="View or add deductions" class="mt-5 underline-primary">View all Deductions</a>


                                       </p>

                                    </div>

                                </div>




                            </div>
                            <div class="col-4">


                                <div class="text-dark">
                                    <div class="text-center">
                                        <div class="text-dark">
                                            <div class="text-center">
                                                <i class="bi bi-cash-coin" style="font-size: 1.8em"></i>
                                                <h6 class="text-font-700 text-dark py-1" v-if="employeeProfile && (employeeProfile.earnings.salary || employeeProfile.earnings.commission )" >{{convertCurrencyToShillings((employeeProfile.earnings.salary + employeeProfile.earnings.commission) - employeeProfile.deductionSum)}}</h6>
                                                <h6 class="text-font-400 text-dark py-1" v-else >0</h6>
                                                <small class="text-dark">Net Earning</small>


                                            </div>

                                        </div>


                                    </div>

                                </div>




                            </div>
                        </div>




                        <div class="my-3">
                            <!--<div class="card-body">-->
                            <!--<div class="text-center text-weight-700 text-primary py-2"><h3 class="border-bottom">Attendance</h3></div>-->


                            <!--&lt;!&ndash;<line-chart :chart-data="datacollection"></line-chart>&ndash;&gt;-->

                            <!--</div>-->

                            <div v-if="employeeProfile.users.orders.length >0">
                                <div class="text-center text-weight-700 text-primary py-2"><h5 >Recent Sales</h5></div>
                                <div v-if="userDetails.roles?.[0]?.name === 'Admin'" class="card shadow-0">
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-md-4 col-6">
                                            <h6>{{this.employeeProfile.countOrders}} - <small>Direct</small></h6>
                                            <!-- <h6>{{this.employeeProfile.users.soldorder.length}} - <small>Inderect</small></h6> -->
                                            <small>All Orders</small>
                                        </div>
                                        <div class="col-md-4 col-6 border-left border-right">
                                            <h6>{{convertCurrencyToShillings(this.employeeProfile.sumOfOrders)}}</h6>
                                            <small>Total Sales</small>
                                        </div>
                                        <div class="col-md-4 col-6">
                                            <h6>{{convertCurrencyToShillings(this.employeeProfile.profit)}}</h6>
                                            <small>Profits</small>
                                        </div>
                                        </div>




                                    </div>
                                </div>
                                <b-table
                                        :items="orderstable.items"
                                        :fields="orderstable.fields"

                                        :per-page="orderstable.perPage"
                                        :current-page="orderstable.currentPage"
                                         sort-icon-left

                                >
<template #cell(index)="data">
    <a :href="'/orders?order-number=' + data.item.id">
        <span class="text-success h3" v-if="data.item.is_direct">.</span>
        <span class="text-danger h3" v-else>.</span>{{ data.index + 1 }}
    </a>
</template>

<template #cell(action)="data">
    <a :href="'/orders?order-number=' + data.item.id">View</a>
</template>

                                </b-table>
                                <b-pagination
                                        v-model="orderstable.currentPage"
                                        :total-rows="rowsOrders"
                                        :per-page="orderstable.perPage"

                                ></b-pagination>
                            </div>
                            <div v-else>
                                <div class=" h-100 d-flex justify-content-center align-items-center">
                                    <div class="text-center mt-5 pt-5">
                                        <img src="/images/embarrassed.png" style="width:100px;" class="img-fluid">
                                        <h6 class="text-center py-3">No recent sales </h6>
                                        <!--<a href="/orders" class="btn btn-primary" >Reload <i class="bi bi-arrow-repeat"></i></a>-->
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </b-modal>
            <b-modal ref="employeemodaldel"  id="bv-modal-delete" hide-footer  static>

                <div class="d-block text-center">
                    <h5 class="text-weight-700 text-danger"><i class="fas fa-trash"></i></h5>
                    <p class="text-weight-500 py-3 text-danger">Are you sure to delete?</p>
                    <div class="row">
                        <div class="col-6">
                            <b-button block @click="$bvModal.hide('bv-modal-delete')">Cancel</b-button>
                        </div>
                        <div class="col-6">
                            <button class="btn btn-danger btn-block" v-on:click="DeleteEmployee(employee_id)">Yes !</button>
                        </div>

                    </div>


                </div>

            </b-modal>
            <b-modal ref="employeedeductions"  id="bv-modal-delete" hide-footer  static>

                <div class="d-block text-center">
                    <div class="d-inline py-3 mb-2">
                        <h5 class="float-left">All Deductions</h5>
                        <a v-on:click="AddDeductionsModal()" class="btn btn-primary mb-2 float-right btn-sm">Add Deductions</a>
                    </div>


                    <b-table
                            :items="deductionsTable.items"
                            :fields="deductionsTable.fields"
                            sort-icon-left

                    >
<template #cell(index)="data">
     {{ data.index + 1 }}
</template>

<template #cell(action)="data">
    <!--<span style="background: #0b2e13; width:30px !important; height:80px" class="text-light">{{ data.index + 1 }}</span>-->
    <div class="d-inline">
        <span title="Delete Deduction" class="underline-primary text-danger mr-1" v-on:click="DeleteDeduction(data.item.deduction_id)"><i class="bi bi-trash"></i></span>
        <span title="Edit Deduction" class="underline-primary mr-1" v-on:click="EditDeductionmodal(data.item.deduction_id)"><i class="bi bi-pencil-square"></i></span>
    </div>
</template>


                    </b-table>




                </div>

            </b-modal>
            <b-modal ref="employeemodalrole"   hide-footer  static>

                <div class="d-block text-center">

                    <p class="text-weight-500 py-3 text-danger">Change User Role?</p>

                    <form v-on:submit="ChangeRole">
                        <div class="form-group">
                            <select v-model="roleselect" class="custom-select">
                                <option disabled value="">Choose Role</option>
                                <option v-for="role in AvailableRoles" :value="role.name">{{role.name}}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <button type="submit" class="btn btn-primary btn-block">Submit</button>
                        </div>
                    </form>





                </div>

            </b-modal>

            <b-modal ref="password-changemodal"  hide-footer static>

                <div class="d-block text-center">

                    <p class="text-weight-500 py-3 text-danger">Change User Password?</p>

                    <form @submit.prevent="changePassword">

                        <div class="input-group mb-3">
                            <div class="custom-file">
                                <input class="form-control" :type="passwordVisible ? 'text' : 'password'" v-model="changeuserpassword">
                            </div>
                            <div class="input-group-append">
                                <span class="btn btn-sm btn-secondary input-group-text" @click="togglePasswordVisibility">
                                {{ passwordVisible ? 'Hide' : 'Show' }} Password
                                </span>
                            </div>
                        </div>
                        <div class="form-group">
                            <button type="submit" class="btn btn-primary btn-block">Submit</button>
                        </div>
                    </form>

                </div>

            </b-modal>
            <b-modal ref="pin-set-modal"  hide-footer static>

                <div class="d-block text-center">

                    <p class="text-weight-500 py-3 text-danger">Set Employee code and Pin?</p>
                    <small>Employees can use this to login</small>

                    <form @submit.prevent="setEmployeeCodeandPin">

                        <div class="form-group">
                            <input v-model="employeeCode.code" type="text" class="form-control" placeholder="Enter Employee Code" />
                        </div>
                        <div class="form-group">
                            <input v-model="employeeCode.pin" type="text" class="form-control" placeholder="Enter PIN" />

                        </div>
                        <div class="form-group">
                            <button type="submit" class="btn btn-primary btn-block">Submit</button>
                        </div>
                    </form>

                </div>

            </b-modal>
            <b-modal ref="edit-employee-modal" size="lg" id="modal-center"  hide-footer  static>
                <div class="text-center">
                    <h5 class="py-3">Edit <span class="text-capitalize">{{ employeeProfile.users.name + "'"}}s</span> Details</h5>

                    <hr/>

                    <div v-if="editEmployeeError" class="card card-danger mb-3">
                        <div class="card-body">
                            <h6 class="text-danger">Could not save changes</h6>
                            <ul class="mb-0">
                                <li v-for="err in editEmployeeError" :key="err[0]">
                                    <span class="text-danger">{{ err[0] }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div v-if="emailReusePrompt" class="alert alert-warning mb-3">
                        <p class="mb-2">
                            <strong>{{ createForm.email }}</strong> was previously used by
                            <strong class="text-capitalize">{{ emailReusePrompt }}</strong> who has been deleted.
                            Do you want to reuse this email?
                        </p>
                        <button type="button" class="btn btn-sm btn-warning mr-2" @click="confirmEmailReuse">Yes, reuse this email</button>
                        <button type="button" class="btn btn-sm btn-outline-secondary" @click="emailReusePrompt = null">Cancel</button>
                    </div>

                    <form @submit.prevent="EditEmployee" class="px-2 text-left" >
                            <div class="form-row">
                                <div class="form-group col-4">
                                    <label>First Name <span class="text-danger">*</span></label>
                                    <input v-model.trim="createForm.first_name" type="text" class="form-control">
                                </div>
                                <div class="form-group col-4">
                                    <label>Middle Name </label>
                                    <input v-model.trim="createForm.middle_name" type="text" class="form-control">
                                </div>
                                <div class="form-group col-4">
                                    <label>Last Name <span class="text-danger">*</span></label>
                                    <input v-model.trim="createForm.last_name" type="text" class="form-control">
                                </div>
                            </div>
                        <div class="form-group py-1">
                            <label>Login Username</label>
                            <input type="text" class="form-control border-dark border" v-model="createForm.username" :placeholder="employeeProfile.users.name" />
                            <small class="text-muted">Leave blank to keep current username</small>
                        </div>
                        <div class="form-group py-1">
                            <label>Email</label>
                            <input type="email" class="form-control border-dark border" v-model="createForm.email" :placeholder="employeeProfile.users.email" />
                        </div>
                        <div class="form-group py-1">
                            <label>Phone Number</label>
                            <input type="text" class="form-control border-dark border" v-model="createForm.phone" :placeholder="employeeProfile.users.phone" />
                        </div>
                        <div >
                              <div class="form-group">
                                <label>Title / Role</label>
                                <input v-model.trim="createForm.title" type="text" class="form-control" placeholder="e.g., Sales Rep">
                            </div>
                            <div class="form-group">
                                <label>Employment Type</label>
                                <select v-model="createForm.modeofemployment" class="form-control">
                                      <option :value="null">— Select —</option>
                                      <option value="permanent">Permanent</option>
                                      <option value="contract">Contract</option>
                                      <option value="casual">Casual</option>
                                      <option value="intern">Intern</option>
                                    </select>
                            </div>
                            <div class="form-group">
                                <label>National ID</label>
                                <input v-model.trim="createForm.national_id" type="text" class="form-control">
                            </div>
                            <div class="form-group">
                                <label>KRA PIN</label>
                                <input v-model.trim="createForm.krapin" type="text" class="form-control" placeholder="A123456789B">
                            </div>
                            <div class="form-group">
                                <label>NHIF No.</label>
                                <input v-model.trim="createForm.nhif" type="text" class="form-control">
                            </div>
                            <div class="form-group">
                                <label>NSSF No.</label>
                                <input v-model.trim="createForm.nssf" type="text" class="form-control">
                            </div>
                        </div>
                        <!-- <div class="form-group py-1">
                            <input type="text" class="form-control border-dark border" v-model="createForm.nssf" placeholder="NSSF"  />
                        </div>
                        <div class="form-group py-1">
                            <input type="text" class="form-control border-dark border" v-model="createForm.nhif" placeholder="NHIF"  />
                        </div>
                        <div class="form-group py-1">
                            <input type="text" class="form-control border-dark border" v-model="createForm.kra" placeholder="KRA PIN"  />
                        </div> -->


                        <div class="form-group py-1">
                            <label>Leave days</label>
                            <input type="text" class="form-control border-dark border" v-model="createForm.leave" :placeholder="'Remaining '+employeeProfile.remainingdays"  />
                        </div>


                        <div class="form-group py-1">
                            <label>Salary</label>
                            <input type="text" class="form-control border-dark border" v-model="createForm.salary" placeholder="Salary "  />
                            <small>Only if applicable </small>
                        </div>

                        <div class="form-group py-1">
                            <label>Commission Structure</label>
                            <select v-model="createForm.commissionStructure" class="form-control">
                                <option value="null">Select commission structure</option>
                                <option value="percentage">Percentage on gross sales</option>
                                <option value="profit">Percentage on net sales</option>
                                <option value="tiered">Tiers commission</option>
                                <option value="fixed">Fixed Commission</option>
                            </select>
                            </div>
                            <small class="text-danger">Only if applicable</small>
                            <div v-if="createForm.commissionStructure ==='percentage' || createForm.commissionStructure ==='profit'">
                                <div class="form-group py-1">
                                    <input type="text" class="form-control border-dark border" v-model="createForm.commissionPercentage" placeholder="Enter Percentage, e.g 3,10 2.5 etc"  required/>
                                </div>
                            </div>
                            <div v-else-if="createForm.commissionStructure ==='tiered'">
                                <div class="form-group py-1">
                                <textarea class="form-control" v-model="createForm.commissionTiers" placeholder=" Eg 2.5 - 100000 3 - 200000 4 - 300000" required >


                                </textarea>
                             </div>
                            </div>
                            <div v-else-if="createForm.commissionStructure ==='fixed'">
                                <div class="form-group py-1">
                                    <input type="text" class="form-control border-dark border" v-model="createForm.commissionAmount" placeholder="Enter commission amount" required  />

                             </div>
                            </div>

                        <div class="form-group py-1">
                            <label>Job Description</label>
                            <textarea  class="form-control border-dark border" v-model="createForm.jobdesc" placeholder="Brief Job Description for this position"></textarea>
                        </div>
                        <div class="form-group py-1">
                            <button class="btn btn-block btn-primary">Submit</button>
                        </div>


                    </form>
                </div>
            </b-modal>
            <!-- Deleted Employees Modal -->
            <b-modal ref="deleted-employees-modal" size="lg" hide-footer static>
                <h5 class="py-3">Deleted Employees</h5>
                <hr/>
                <div v-if="deletedEmployees.length === 0" class="text-center text-muted py-4">
                    No deleted employees found.
                </div>
                <div v-else>
                    <table class="table table-sm table-bordered">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Title</th>
                                <th>Deleted</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="emp in deletedEmployees" :key="emp.id">
                                <td class="text-capitalize">{{ [emp.first_name, emp.last_name].filter(Boolean).join(' ') || (emp.users && emp.users.name) || '—' }}</td>
                                <td>{{ emp.email || (emp.users && emp.users.email) || '—' }}</td>
                                <td>{{ emp.title || '—' }}</td>
                                <td>{{ FormatDate(emp.deleted_at) }}</td>
                                <td>
                                    <button class="btn btn-sm btn-outline-success" @click="restoreEmployee(emp.id)">Restore</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </b-modal>

            <b-modal ref="add_deduction_modal" size="md" id="modal-center"  hide-footer  static>
                <div class="text-center">
                    <h5 class="py-3">Add Deductions to {{ (employeeProfile !== '')? employeeProfile.users.name : ''}}</h5>
                    <hr/>

                    <form @submit="AddDeductions" class="px-2 text-left" >
                        <div class="form-group">
                            <input type="text" class="form-control border-dark border" v-model="deductionsform.deduction" placeholder="Deduction"  required/>

                        </div>
                        <div class="form-group py-1">
                            <input type="text" class="form-control border-dark border" v-model="deductionsform.amount" placeholder="Amount" required/>
                        </div>
                        <div class="form-group py-1">
                            <input type="text" class="form-control border-dark border" v-model="deductionsform.description" placeholder="Brief description" />
                        </div>
                        <b-form-group label="Frequency">
                            <b-form-radio v-model="deductionsform.recurring" value="1">Every Month</b-form-radio>
                            <b-form-radio v-model="deductionsform.recurring" value="0">Once</b-form-radio>
                        </b-form-group>

                        <div class="form-group py-1">
                            <button class="btn btn-block btn-primary">Create Deduction</button>
                        </div>


                    </form>
                </div>
            </b-modal>
            <b-modal ref="permissions_modal" size="md" id="modal-center"  hide-footer  static>
                <div class="text-center">
                    <h5 class="py-1"> <span class="text-capitalize">{{ (employeeProfile !== '')? employeeProfile.users.name : ''}}'s - </span> permissions</h5>
                    <hr/>

                    <form @submit.prevent="setPermissions" class="px-2 text-left" >


                        <p>You can add or revoke user permissions</p>

                            <p class="text-muted font-weight-bold mt-2 mb-1" style="font-size:0.75rem;text-transform:uppercase;">Orders</p>
                            <b-form-checkbox-group id="perm-orders" v-model="userPermissions.selectedPermissions" stacked>
                                <b-form-checkbox value="view-orders"><p>View orders</p></b-form-checkbox>
                                <b-form-checkbox value="create-orders"><p>Create orders (POS)</p></b-form-checkbox>
                                <b-form-checkbox value="delete-orders"><p>Delete pending orders</p></b-form-checkbox>
                                <b-form-checkbox value="void-orders"><p>Void / refund orders</p></b-form-checkbox>
                                <b-form-checkbox value="override-print-limit"><p>Override receipt print limit</p></b-form-checkbox>
                                <b-form-checkbox value="skip_payment_validation"><p>Approve skipping payment validation</p></b-form-checkbox>
                                <b-form-checkbox value="can see daily sales breakdown"><p>View daily sales breakdown</p></b-form-checkbox>
                                <b-form-checkbox value="can manage orders"><p>Can manage orders <small class="text-muted">(legacy — grants all of the above)</small></p></b-form-checkbox>
                            </b-form-checkbox-group>

                            <p class="text-muted font-weight-bold mt-3 mb-1" style="font-size:0.75rem;text-transform:uppercase;">Inventory</p>
                            <b-form-checkbox-group id="perm-inventory" v-model="userPermissions.selectedPermissions" stacked>
                                <b-form-checkbox value="view-inventory"><p>View inventory</p></b-form-checkbox>
                                <b-form-checkbox value="edit-products"><p>Create / edit products</p></b-form-checkbox>
                                <b-form-checkbox value="adjust-stock"><p>Adjust stock counts</p></b-form-checkbox>
                                <b-form-checkbox value="view-stock-ledger"><p>View stock ledger</p></b-form-checkbox>
                                <b-form-checkbox value="can manage inventory"><p>Can manage inventory <small class="text-muted">(legacy — grants all of the above)</small></p></b-form-checkbox>
                                <b-form-checkbox value="can transfer"><p>Transfer stock between branches</p></b-form-checkbox>
                                <b-form-checkbox value="can receive stock"><p>Receive stock (GRN)</p></b-form-checkbox>
                                <b-form-checkbox value="view-recipes"><p>View recipes &amp; grouped items</p></b-form-checkbox>
                                <b-form-checkbox value="edit-recipes"><p>Create / edit recipes &amp; grouped items</p></b-form-checkbox>
                                <b-form-checkbox value="make-batches"><p>Make batches &amp; discard leftovers <small class="text-muted">(items prepared in batches, e.g. chips)</small></p></b-form-checkbox>
                            </b-form-checkbox-group>

                            <p class="text-muted font-weight-bold mt-3 mb-1" style="font-size:0.75rem;text-transform:uppercase;">Purchasing</p>
                            <b-form-checkbox-group id="perm-purchasing" v-model="userPermissions.selectedPermissions" stacked>
                                <b-form-checkbox value="view-purchases"><p>View purchase orders</p></b-form-checkbox>
                                <b-form-checkbox value="can manage suppliers"><p>Manage suppliers &amp; purchase orders</p></b-form-checkbox>
                            </b-form-checkbox-group>

                            <p class="text-muted font-weight-bold mt-3 mb-1" style="font-size:0.75rem;text-transform:uppercase;">Quotes &amp; Invoices</p>
                            <b-form-checkbox-group id="perm-quotes-invoices" v-model="userPermissions.selectedPermissions" stacked>
                                <b-form-checkbox value="view_quotes"><p>View quotes</p></b-form-checkbox>
                                <b-form-checkbox value="create_quotes"><p>Create quotes</p></b-form-checkbox>
                                <b-form-checkbox value="edit_quotes"><p>Edit quotes</p></b-form-checkbox>
                                <b-form-checkbox value="cancel_quotes"><p>Cancel quotes</p></b-form-checkbox>
                                <b-form-checkbox value="view_invoices"><p>View invoices</p></b-form-checkbox>
                                <b-form-checkbox value="create_invoices"><p>Create invoices / convert quotes</p></b-form-checkbox>
                                <b-form-checkbox value="edit_invoices"><p>Edit invoices</p></b-form-checkbox>
                                <b-form-checkbox value="record_invoice_payment"><p>Record invoice payments</p></b-form-checkbox>
                                <b-form-checkbox value="cancel_invoices"><p>Cancel invoices</p></b-form-checkbox>
                            </b-form-checkbox-group>

                            <p class="text-muted font-weight-bold mt-3 mb-1" style="font-size:0.75rem;text-transform:uppercase;">Expenses</p>
                            <b-form-checkbox-group id="perm-expenses" v-model="userPermissions.selectedPermissions" stacked>
                                <b-form-checkbox value="create-expenses"><p>Submit expense claims</p></b-form-checkbox>
                                <b-form-checkbox value="approve-expenses"><p>Approve / reject expenses</p></b-form-checkbox>
                                <b-form-checkbox value="view-expenses"><p>View expense ledger</p></b-form-checkbox>
                                <b-form-checkbox value="can manage expenses"><p>Can manage expenses <small class="text-muted">(legacy — grants all of the above)</small></p></b-form-checkbox>
                                <b-form-checkbox value="can manage wastes"><p>Manage waste records</p></b-form-checkbox>
                            </b-form-checkbox-group>

                            <p class="text-muted font-weight-bold mt-3 mb-1" style="font-size:0.75rem;text-transform:uppercase;">Staff &amp; Settings</p>
                            <b-form-checkbox-group id="perm-staff" v-model="userPermissions.selectedPermissions" stacked>
                                <b-form-checkbox value="view-employees"><p>View employee list</p></b-form-checkbox>
                                <b-form-checkbox value="manage-employees"><p>Create / edit employees</p></b-form-checkbox>
                                <b-form-checkbox value="manage-roles-permissions"><p>Assign roles &amp; permissions</p></b-form-checkbox>
                                <b-form-checkbox value="can manage users"><p>Can manage users <small class="text-muted">(legacy — grants all of the above)</small></p></b-form-checkbox>
                                <b-form-checkbox value="can switch branches"><p>Switch to other branches</p></b-form-checkbox>
                                <b-form-checkbox value="change-general-settings"><p>Change general settings</p></b-form-checkbox>
                                <b-form-checkbox value="change-inventory-settings"><p>Change inventory settings</p></b-form-checkbox>
                                <b-form-checkbox value="can change settings"><p>Can change settings <small class="text-muted">(legacy — grants all of the above)</small></p></b-form-checkbox>
                            </b-form-checkbox-group>

                            <p class="text-muted font-weight-bold mt-3 mb-1" style="font-size:0.75rem;text-transform:uppercase;">Analytics</p>
                            <b-form-checkbox-group id="perm-analytics" v-model="userPermissions.selectedPermissions" stacked>
                                <b-form-checkbox value="view-analytics"><p>View sales analytics &amp; reports</p></b-form-checkbox>
                                <b-form-checkbox value="view-financial-reports"><p>View financial reports</p></b-form-checkbox>
                                <b-form-checkbox value="view-profit-loss"><p>View profit &amp; loss</p></b-form-checkbox>
                                <b-form-checkbox value="export-financial-data"><p>Export financial data</p></b-form-checkbox>
                            </b-form-checkbox-group>

                            <div v-if="userDetails.company && userDetails.company.companysettings && userDetails.company.companysettings.has_subscriptions">
                                <p class="text-muted font-weight-bold mt-3 mb-1" style="font-size:0.75rem;text-transform:uppercase;">
    Subscriptions
</p>

<b-form-checkbox-group id="perm-subscriptions" v-model="userPermissions.selectedPermissions" stacked>

    <!-- Dashboard & Viewing -->
    <b-form-checkbox value="subscriptions.view_dashboard">
        <p>Access subscription dashboard</p>
    </b-form-checkbox>

    <b-form-checkbox value="subscriptions.view">
        <p>View subscriptions</p>
    </b-form-checkbox>

    <b-form-checkbox value="subscriptions.view_attendance">
        <p>View attendance logs</p>
    </b-form-checkbox>

    <!-- Core Actions -->
    <b-form-checkbox value="subscriptions.create">
        <p>Create subscriptions</p>
    </b-form-checkbox>

    <b-form-checkbox value="subscriptions.edit">
        <p>Edit subscriptions</p>
    </b-form-checkbox>

    <b-form-checkbox value="subscriptions.renew">
        <p>Renew subscriptions</p>
    </b-form-checkbox>

    <b-form-checkbox value="subscriptions.cancel">
        <p>Cancel subscriptions</p>
    </b-form-checkbox>

    <b-form-checkbox value="subscriptions.delete">
        <p>Delete subscriptions</p>
    </b-form-checkbox>

    <!-- Financial -->
    <b-form-checkbox value="subscriptions.view_financials">
        <p>View financials</p>
    </b-form-checkbox>

    <b-form-checkbox value="subscriptions.manage_payments">
        <p>Manage payments</p>
    </b-form-checkbox>

    <b-form-checkbox value="subscriptions.apply_discount">
        <p>Apply discounts</p>
    </b-form-checkbox>

    <b-form-checkbox value="subscriptions.manage_wallet">
        <p>Manage customer wallet</p>
    </b-form-checkbox>

    <b-form-checkbox value="subscriptions.clear_balance">
        <p>Clear wallet balance</p>
    </b-form-checkbox>

    <!-- Operations -->
    <b-form-checkbox value="subscriptions.checkin">
        <p>Check-in / attendance scanning</p>
    </b-form-checkbox>

    <b-form-checkbox value="subscriptions.manage_qrcodes">
        <p>Manage QR codes</p>
    </b-form-checkbox>

    <!-- Packages -->
    <b-form-checkbox value="subscriptions.manage_packages">
        <p>Manage subscription packages</p>
    </b-form-checkbox>

</b-form-checkbox-group>
                            </div>

                            <div v-if="userDetails.company && userDetails.company.companysettings && userDetails.company.companysettings.has_reservations">
                                <p class="text-muted font-weight-bold mt-3 mb-1" style="font-size:0.75rem;text-transform:uppercase;">Reservations</p>
                                <b-form-checkbox-group id="perm-reservations" v-model="userPermissions.selectedPermissions" stacked>
                                    <b-form-checkbox value="reservations.cancel"><p>Cancel bookings</p></b-form-checkbox>
                                    <b-form-checkbox value="reservations.night_audit"><p>Run night audit</p></b-form-checkbox>
                                </b-form-checkbox-group>
                            </div>


                        <div class="form-group py-1">
                            <button class="btn btn-block btn-primary">Add/Revoke Permissions</button>
                        </div>


                    </form>
                </div>
            </b-modal>
            <b-modal ref="editdeductionmodal" size="md" id="modal-center"  hide-footer  static>
                <div class="text-center">
                    <h5 class="py-3">Edit Deductions</h5>
                    <hr/>

                    <form @submit="EditDeduction" class="px-2 text-left" >
                        <div class="form-group">
                            <input type="text" class="form-control border-dark border" v-model="deductionsform.deduction" placeholder="Deduction"  />

                        </div>
                        <div class="form-group py-1">
                            <input type="text" class="form-control border-dark border" v-model="deductionsform.amount" placeholder="Amount" />
                        </div>
                        <div class="form-group py-1">
                            <input type="text" class="form-control border-dark border" v-model="deductionsform.description" placeholder="Brief description" />
                        </div>
                        <b-form-group label="Frequency">
                            <b-form-radio v-model="deductionsform.recurring" value="1">Every Month</b-form-radio>
                            <b-form-radio v-model="deductionsform.recurring" value="0">Once</b-form-radio>
                        </b-form-group>

                        <div class="form-group py-1">
                            <button class="btn btn-block btn-primary">Submit</button>
                        </div>


                    </form>
                </div>
            </b-modal>

        </div>





    </div>
</template>

<script>
    import DateRangePicker from "vue2-daterange-picker/src/components/DateRangePicker";
    import LineChart from '../analytics/charts/employeeattendance.vue';
    import EmployeeAllowances from './EmployeeAllowances.vue';
    import EmployeeDeductions from './EmployeeDeductions.vue';
    import EmployeeCommission from './EmployeeCommission.vue';
    import {
        mapGetters
    } from "vuex";
    export default {
        name: 'employee',
        components: {
            DateRangePicker,
            LineChart,
            EmployeeAllowances,
            EmployeeDeductions,
            EmployeeCommission,
        },
        data() {
            return {
                tab: 'details',
                saving: false,
                error: '',
                employees: '',
                datacollection: null,
                employeeorders: '',
                employeeProfile: {
                    deductionSum: 0,
                    users: {
                        orders: [],
                    },
                    earnings: {},
                },
                employee_id: '',
                deduction_id: '',
                password: '',
                passwordVisible: false,
                deductionsform: {
                    recurring: '',
                    amount: '',
                    description: '',
                    deduction: '',
                    user_id: '',
                },
                createForm: {
                    full_name: '',
                    first_name: '',
                    middle_name: '',
                    last_name: '',
                    email: '',
                    username: '',
                    salary: '',
                    commissionStructure: null,
                    modeofemployment: null,
                    jobdesc: '',
                    phone: '',
                    commissionTiers: '',
                    commissionPercentage: '',
                    commissionAmount: '',
                    onlyForPayroll: true,
                    title: '',
                    jobdescription: '',
                    leavedays: 21,
                    employee_code: '',
                    national_id: '',
                    krapin: '',
                    nhif: '',
                    nssf: '',
                    bank_name: '',
                    bank_branch: '',
                    bank_account_name: '',
                    bank_account_number: '',
                    pension_contrib: 0,
                    insurance_premium: 0,
                    mortgage_interest: 0,
                    helb_amount: 0,
                    status: 'active',
                    password:'',
                    force_email_reuse: false,
                },
                employeeCode: {
                    code: '',
                    pin: '',
                    id: '',
                },
                userPermissions: {
                    selectedPermissions: []
                },
                roleselect: '',
                AvailableRoles: '',
                items: [],
                fields: [
                    "index",
                    {
                        key: "name",
                        sortable: true
                    },
                    {
                        key: "job_title",
                        sortable: true
                    },
                    {
                        key: "modeofemployment",
                        sortable: true,
                        label: "Mode of Employment"
                    },
                ],
                searchemployee: '',
                changeuserpassword: null,
                show: true,
                orderstable: {
                    fields: [
                        'index',
                        {
                            key: 'order',
                            sortable: true
                        },
                        {
                            key: 'amount',
                            sortable: true
                        },
                        {
                            key: 'date',
                            sortable: true
                        },
                        {
                            key: 'action',
                            sortable: false
                        },
                    ],
                    items: [],
                    perPage: 10,
                    currentPage: 1,
                },
                deductionsTable: {
                    fields: [
                        'index',
                        {
                            key: 'deduction',
                            sortable: true
                        },
                        {
                            key: 'amount',
                            sortable: true
                        },
                        {
                            key: 'recurring',
                            sortable: true
                        },
                        {
                            key: 'action',
                            sortable: true
                        },
                    ],
                    items: [],
                },
                autoApply: true,
                employeeCreationError: null,
                editEmployeeError: null,
                emailReusePrompt: null,
                deletedEmployees: [],
                dateRange: {
                    startDate: null,
                    endDate: null,
                },
            }
        },
        mounted() {
            this.getEmployees()
            this.checkIfEmployeeIdSet()
        },
        computed: {
            rowsOrders() {
                return this.orderstable.items.length
            },
            filteredEmployees() {
                return this.items.filter(item => {
                    const itemName = item.name ? item.name.toLowerCase() : '';
                    return itemName.includes(this.searchemployee.toLowerCase());
                });
            },
            ...mapGetters(['userDetails'])
        },
        watch: {
            "createForm.commissionStructure": function() {
                if (this.createForm.commissionStructure !== null) {
                    //console.log(this.createForm.commissionStructure)
                }
            },
            dateRange: {
                deep: true,
                handler(after, before) {
                    if (after.startDate && after.endDate) {
                        const urlParams = new URLSearchParams(window.location.search);
                        const startDateString = after.startDate.toISOString().split('T')[0]; // Convert to ISO format without time
                        const endDateString = after.endDate.toISOString().split('T')[0]; // Convert to ISO format without time
                        urlParams.set('start-date', startDateString);
                        urlParams.set('end-date', endDateString);
                        window.history.replaceState(null, null, '?' + urlParams.toString());
                    }
                    this.employeeProfileDetails(this.employeeProfile.id)
                }
            }
        },
        methods: {
            RowSelected(items) {
                // console.log(items);
                this.employeeProfileDetails(items.id);
            },
            setPermissions() {
                axios.post('/api/user-permissions', {
                        empId: this.employee_id,
                        permissions: this.userPermissions.selectedPermissions
                    })
                    .then(result => {
                        if (result.status === 200) {
                            this.$toasts.push({
                                type: 'success',
                                message: "Employee permissions has been updated",
                            });
                            this.$refs.permissions_modal.hide();
                        }
                    });
            },
            EditEmployeeModal() {
                this.editEmployeeError = null;
                this.emailReusePrompt = null;
                this.createForm.force_email_reuse = false;
                this.$refs['employee_profile'].hide();
                this.$refs['edit-employee-modal'].show();
            },
            togglePasswordVisibility() {
                this.passwordVisible = !this.passwordVisible;
            },
            ChangeRole(e) {
                e.preventDefault();
                axios.post('/api/changerole', {
                        emp_id: this.employee_id,
                        role: this.roleselect
                    })
                    .then(result => {
                        if (result.status === 200) {
                            // console.log(this.employee_id);
                            this.$toasts.push({
                                type: 'success',
                                message: "Employee role has been updated",
                            });
                            this.$refs['employeemodalrole'].hide();
                            this.employeeProfileDetails(this.employee_id)
                        }
                    });
            },
            changePassword() {
                if (this.changeuserpassword !== null) {
                    axios.post('/api/changepassword', {
                            emp_id: this.employee_id,
                            password: this.changeuserpassword
                        })
                        .then(result => {
                            if (result.status === 200) {
                                // console.log(this.employee_id);
                                this.$toasts.push({
                                    type: 'success',
                                    message: "Employee password has been updated",
                                });
                                this.$refs['password-changemodal'].hide();
                                this.employeeProfileDetails(this.employee_id)
                            } else {
                                // console.log(result.data);
                                this.$toasts.push({
                                    type: 'error',
                                    message: "There was an error ",
                                });
                            }
                        });
                } else {
                    this.$toasts.push({
                        type: 'error',
                        message: "Password cannot be null",
                    });
                }
            },
            setEmployeeCodeandPin() {
                this.employeeCode.id = this.employee_id
                axios.post('/api/set-employee-passcode', { ...this.employeeCode
                    })
                    .then(result => {
                        if (result.data.exist) {
                            this.$toasts.push({
                                type: 'error',
                                message: result.data.message,
                            });
                        } else {
                            window.location.reload()
                        }
                    });
            },
            ShowRoleModal(emp_id) {
                axios.get('/api/allroles')
                    .then(result => {
                        this.AvailableRoles = result.data;
                        this.$refs['employeemodalrole'].show();
                    });
                this.employee_id = emp_id
            },
            changePasswordModal() {
                this.$refs['password-changemodal'].show();
            },
            setEmployeePinModal() {
                this.$refs['pin-set-modal'].show();
            },
            setPermissionModal() {
                this.$refs.permissions_modal.show();
            },
            SalaryAdvance() {
                axios.get('/api/allroles')
                    .then(result => {
                        this.AvailableRoles = result.data;
                        this.$refs['employeemodalrole'].show();
                    });
                this.employee_id = emp_id
            },
            LeaveApplications() {
                axios.get('/api/allroles')
                    .then(result => {
                        this.AvailableRoles = result.data;
                        this.$refs['employeemodalrole'].show();
                    });
                this.employee_id = emp_id
            },
            DeleteEmployee(emp_id) {
                axios.delete('/api/employee', {
                        params: {
                            emp_id: emp_id
                        }
                    })
                    .then(result => {
                        this.$toasts.push({
                            type: result.data.type,
                            message: "Employee deleted successfully",
                        });
                        this.$refs['employeemodaldel'].hide();
                        window.location.reload()
                    });
            },
            getEmployees() {
                axios.get('/api/employees')
                    .then(result => {
                        this.employees = result.data;
                        this.items = result.data;
                    }).catch(error => {
                        // console.log(error.response.data)
                    });
            },
            DeleteEmployeeModal(emp_id) {
                this.employee_id = emp_id;
                this.$refs['employeemodaldel'].show();
                this.$refs['employee_profile'].hide();
            },
            CreateEmployeeModal() {
                this.$refs['create-employee-modal'].show();
            },
            newEmployeeSubmit() {
                this.employeeCreationError = null;
                axios.post('/api/employee', {
                       ...this.createForm
                    })
                    .then(result => {
                        this.$toasts.push({
                            type: 'success',
                            message: "Employee has been created successfully",
                        });
                        this.$refs['create-employee-modal'].hide();
                        window.location.href = '/employees'
                    })
                    .catch(err => {
                        if (err.response && err.response.data && err.response.data.errors) {
                            this.employeeCreationError = err.response.data.errors;
                        } else if (err.response && err.response.data && err.response.data.message) {
                            this.employeeCreationError = { general: [err.response.data.message] };
                        } else {
                            this.employeeCreationError = { general: ['An unexpected error occurred. Please try again.'] };
                        }
                    });
            },
            newPayrollEmployeeSubmit() {
                this.employeeCreationError = null;
                axios.post('/api/employee', {
                        ...this.createForm
                    })
                    .then(result => {
                        this.$toasts.push({
                            type: 'success',
                            message: "Employee has been created successfully",
                        });
                        this.$refs['create-employee-modal'].hide();
                        window.location.href = '/employees'
                    }).catch(er => {
                        if (er.response && er.response.data && er.response.data.errors) {
                            this.employeeCreationError = er.response.data.errors;
                        } else if (er.response && er.response.data && er.response.data.message) {
                            this.employeeCreationError = { general: [er.response.data.message] };
                        } else {
                            this.employeeCreationError = { general: ['An unexpected error occurred. Please try again.'] };
                        }
                    });
            },
            EditEmployee() {
                this.editEmployeeError = null;
                this.emailReusePrompt = null;
                this.createForm.employeeId = this.employeeProfile.id;
                axios.post('/api/edit-employee', { ...this.createForm })
                    .then(result => {
                        if (result.status === 200) {
                            this.$toasts.push({ type: 'success', message: "Employee has been updated successfully" });
                            this.createForm.force_email_reuse = false;
                            this.$refs['edit-employee-modal'].hide();
                            this.getEmployees();
                        }
                    })
                    .catch(err => {
                        if (!err.response) {
                            this.editEmployeeError = { general: ['An unexpected error occurred. Please try again.'] };
                            return;
                        }
                        const data = err.response.data;
                        if (err.response.status === 409 && data.status === 'email_taken_by_deleted') {
                            this.emailReusePrompt = data.deleted_name;
                        } else if (data.errors) {
                            this.editEmployeeError = data.errors;
                        } else if (data.message) {
                            this.editEmployeeError = { general: [data.message] };
                        } else {
                            this.editEmployeeError = { general: ['An unexpected error occurred. Please try again.'] };
                        }
                    });
            },
            confirmEmailReuse() {
                this.createForm.force_email_reuse = true;
                this.emailReusePrompt = null;
                this.EditEmployee();
            },
            ShowDeductions() {
                this.$refs['employeedeductions'].show();
                this.$refs['employee_profile'].hide();
            },
            checkIfEmployeeIdSet() {
                const urlParams = new URLSearchParams(window.location.search);
                if (urlParams.has('emp_id')) {
                    this.employeeProfileDetails(urlParams.get('emp_id'))
                }
            },
            employeeProfileDetails(employee_id) {
                const urlParams = new URLSearchParams(window.location.search);
                axios.get('/api/employee/details', {
                        params: {
                            employee_id: employee_id,
                            startDate: urlParams.get('start-date'),
                            endDate: urlParams.get('end-date'),
                        }
                    })
                    .then(result => {
                        this.employee_id = result.data.id
                        this.$refs['employee_profile'].show();
                        const employeeUserProfile = result.data.users
                        this.employeeProfile = result.data;
                        this.userPermissions.selectedPermissions = (employeeUserProfile.permissions) ? employeeUserProfile.permissions.map(permission => permission.name) : []
                        // console.log(employeeUserProfile)
                        let ordersData = []
                        $.each(this.employeeProfile.users.orders, function(key, value) {
                            ordersData.push({
                                order: value.order,
                                id: value.id,
                                date: moment(value.created_at).format('HH:mm DD-MM-YYYY'),
                                is_direct: true,
                                amount: value.total_amount
                            })
                        });
                        $.each(this.employeeProfile.users.soldorder, function(key, value) {
                            ordersData.push({
                                order: value.finalorder.order,
                                id: value.finalorder.id,
                                date: moment(value.created_at).format('HH:mm DD-MM-YYYY'),
                                is_direct: false,
                                amount: value.finalorder.total_amount
                            })
                        });
                        this.orderstable.items = ordersData;
                        let totaldeductions = [];
                        let totalDeductionsTable = [];
                        $.each(this.employeeProfile.users.deductions, function(key, value) {
                            totaldeductions.push(value.amount);
                            let recur = (value.recurring === 1) ? 'True' : 'Once';
                            totalDeductionsTable.push({
                                deduction: value.deduction,
                                amount: value.amount,
                                recurring: recur,
                                deduction_id: value.id
                            })
                        });
                        this.deductionsTable.items = totalDeductionsTable;
                        this.employeeProfile.deductionSum = totaldeductions.reduce(function(a, b) {
                            return a + b;
                        }, 0);
                        this.fillData();
                    });
            },
            openDeletedEmployeesModal() {
                axios.get('/api/deleted-employees')
                    .then(res => {
                        this.deletedEmployees = res.data;
                        this.$refs['deleted-employees-modal'].show();
                    })
                    .catch(() => {
                        this.$toasts.push({ type: 'error', message: 'Could not load deleted employees.' });
                    });
            },
            restoreEmployee(employeeId) {
                axios.post('/api/restore-employee', { employee_id: employeeId })
                    .then(() => {
                        this.$toasts.push({ type: 'success', message: 'Employee restored successfully.' });
                        this.deletedEmployees = this.deletedEmployees.filter(e => e.id !== employeeId);
                        this.getEmployees();
                    })
                    .catch(err => {
                        const msg = err.response && err.response.data && err.response.data.message
                            ? err.response.data.message
                            : 'Could not restore employee.';
                        this.$toasts.push({ type: 'error', message: msg });
                    });
            },
            FormatDate(date) {
                let finaldate = moment(date).format('DD-MMM-YYYY');
                return finaldate;
            },
            fillData() {
                this.datacollection = {
                    labels: [this.getRandomInt(), this.getRandomInt()],
                    datasets: [{
                        label: 'Data One',
                        backgroundColor: '#f87979',
                        data: [this.getRandomInt(), this.getRandomInt()]
                    }, {
                        label: 'Data One',
                        backgroundColor: '#f87979',
                        data: [this.getRandomInt(), this.getRandomInt()]
                    }]
                }
            },
            getRandomInt() {
                return Math.floor(Math.random() * (50 - 5 + 1)) + 5
            },
            EditDeductionmodal(id) {
                this.$refs['editdeductionmodal'].show();
                this.deduction_id = id;
            },
            EditDeduction(e) {
                e.preventDefault();
                axios.put(`/api/deductions/${this.deduction_id}`, {
                    amount: this.deductionsform.amount,
                    deduction: this.deductionsform.deduction,
                    description: this.deductionsform.description,
                    deductions_id: this.deduction_id,
                    recurring: this.deductionsform.recurring
                }).then(results => {
                    this.$refs['add_deduction_modal'].hide();
                    this.$toasts.push({
                        type: results.data.type,
                        message: results.data.message,
                    })
                }).catch(errorresponse => {
                    // console.log(errorresponse);
                });
            },
            DeleteDeduction(id) {
                // console.log(id);
                axios.delete(`/api/deductions/${id}`).then(results => {
                    this.$refs['employeedeductions'].hide();
                    this.$toasts.push({
                        type: results.data.type,
                        message: results.data.message,
                    })
                }).catch(errorresponse => {
                    // console.log(errorresponse.data);
                });
            },
            AddDeductions(e) {
                e.preventDefault();
                axios.post('/api/deductions', {
                    amount: this.deductionsform.amount,
                    deduction: this.deductionsform.deduction,
                    description: this.deductionsform.description,
                    user_id: this.employeeProfile.users.id,
                    recurring: this.deductionsform.recurring
                }).then(results => {
                    this.$refs['add_deduction_modal'].hide();
                    this.$toasts.push({
                        type: results.data.type,
                        message: results.data.message,
                    })
                }).catch(errorresponse => {
                    // console.log(errorresponse);
                });
            },
            AddDeductionsModal() {
                this.$refs['employeedeductions'].hide();
                this.$refs['add_deduction_modal'].show();
            },
        }
    }
</script>
